const PUBLIC_DOCUMENT_SHARE_LINK_PATH =
	/^\/documents\/share-links\/[^/]+(?:\/(?:resolution|download))?\/?$/;

export function isPublicDocumentShareLinkRequest(url: string): boolean {
	return PUBLIC_DOCUMENT_SHARE_LINK_PATH.test(getPathname(url));
}

export function isProtectedClaimMosaicApiRequest(
	url: string,
	apiBaseUrl: string,
): boolean {
	return (
		isClaimMosaicApiRequest(url, apiBaseUrl) &&
		!isPublicDocumentShareLinkRequest(url)
	);
}

function isClaimMosaicApiRequest(url: string, apiBaseUrl: string): boolean {
	const requestUrl = parseUrl(url);
	const baseUrl = parseUrl(apiBaseUrl);

	if (!requestUrl || !baseUrl || requestUrl.origin !== baseUrl.origin) {
		return false;
	}

	const basePath = normalizeBasePath(baseUrl.pathname);
	if (!basePath) {
		return true;
	}

	return (
		requestUrl.pathname === basePath ||
		requestUrl.pathname.startsWith(`${basePath}/`)
	);
}

function getPathname(url: string): string {
	return parseUrl(url)?.pathname ?? normalizeFallbackPath(url);
}

function parseUrl(url: string): URL | null {
	try {
		return new URL(url, getFallbackOrigin());
	} catch {
		return null;
	}
}

function getFallbackOrigin(): string {
	if (typeof window !== 'undefined' && window.location?.origin) {
		return window.location.origin;
	}

	return 'http://localhost';
}

function normalizeBasePath(pathname: string): string {
	const path = pathname.replace(/\/+$/, '');
	return path === '/' ? '' : path;
}

function normalizeFallbackPath(url: string): string {
	const path = url.split(/[?#]/, 1)[0] ?? '';
	return path.startsWith('/') ? path : `/${path}`;
}
